import { Component, Input, OnChanges } from "@angular/core";
import { DurationFormatService } from "./duration-format.service";

@Component({
  selector: "ab-duration-format",
  templateUrl: "./duration-format.component.html",
})
export class DurationFormatComponent implements OnChanges {
  @Input() public milliseconds: number;
  public value: string;
  public unit: string;

  constructor(private durationFormatService: DurationFormatService) {}

  public ngOnChanges() {
    [this.value, this.unit] = this.durationFormatService.format(
      this.milliseconds,
    );
  }
}
